const usePushNotifications = () => {
  throw new Error("not implemented on web.");
};

export default usePushNotifications;
